<template>
  <div class="home-container">

    <el-card style="margin-top: 10px; background-color: #FFF5EE">
      <div style="display: flex;justify-content: flex-end;">
        <div style="display: flex">
          <div style="flex: 1">
            <el-input v-model="name" placeholder="请输入内容"></el-input>
          </div>
          <div style="flex: 1">
            <el-button style="margin-left: 10px;" @click="load">搜索</el-button>
            <el-button style="margin-left: 10px;" type="warning" @click="reset">重置</el-button>
          </div>
        </div>

      </div>
    </el-card>

    <div class="item-center">
      <div ref="parent" class="parent">
      <el-row :gutter="24">
        <el-col :span="calculateSpan">

          <el-row :gutter="10">
            <el-col :span="6" v-for="item in items" :key="item.id" :class="getImageClass()"style="margin-bottom: 10px">
              <div style="border: 1px solid #ccc; padding-bottom: 10px; border-radius: 10px; overflow: hidden; cursor: pointer" @click="$router.push('/front/threeDetail?id=' + item.id)">
                <img :src="item.img" style="width: 100%; height: 200px; overflow: hidden; border-radius: 10px">
                <div style="color: #000; margin: 10px" class="info">名称:{{ item.name }}</div>
                <div style="margin: 10px;color: #8c939d;" class="info">简介:{{ item.content }}</div>
              </div>
            </el-col>
          </el-row>
          <div style="margin: 10px 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[8 , 16]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>

        </el-col>

        <el-col v-if="!isNavCollapsed" :span="7">

          <el-card style="background-color: #FFF5EE">
            <el-carousel height="300px" :interval="10000">
              <el-carousel-item v-for="item in imgs" :key="item">
                <img :src="item" style="width: 100%;height: 100%">
              </el-carousel-item>
            </el-carousel>
          </el-card>

        </el-col>
        <el-col  v-else :span="0">
        </el-col>
      </el-row>
      </div>
    </div>

  </div>
</template>

<script>

export default {//@click="goToUrl(item.url)"
  name: "",
  data() {
    return {
      isNavCollapsed: false, // 控制导航栏是否折叠
      isNavExpanded: false, // 控制下拉菜单是否展开
      parentWidth: window.innerWidth, // 初始宽度，将在mounted中更新
      items:[],
      types:[],
      typeId:0,
      name:'',
      pageNum:1,
      pageSize:8,
      total:0,
      imgs: [
        "http://47.108.174.230:9090/file/33d5d474eb5c4802a107495589af1e7e.jpg",
        "http://47.108.174.230:9090/file/c9cfaa7011aa41dd8301c3e81461349e.jpg",
        "http://47.108.174.230:9090/file/ff9babe6f3d7439ba9e3bbc7e190cb0e.jpg",
      ],
    };
  },
  created(){
    this.load()
    this.loadType()
  },
  mounted() {
    // 页面加载时从localStorage中读取状态
    this.selectedButton = localStorage.getItem('selectedButton') || '';
    window.addEventListener('resize', this.updateParentWidth);
    this.updateParentWidth();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateParentWidth);
  },
  computed: {
    calculateSpan(){
      return this.isNavCollapsed ? 24:17
    },
    // 计算图片列数
    imageColumns() {
      if (this.parentWidth < 350) {
        return 1;
      } else if (this.parentWidth < 750) {
        return 2;
      } else {
        return 4;
      }
    },
  },
  methods:{
    updateParentWidth() {
      this.parentWidth = this.$refs.parent.offsetWidth;
      this.checkNavCollapse();
    },
    checkNavCollapse() {
      this.isNavCollapsed = this.parentWidth < 500;
    },
    getImageClass() {
      const baseClass = 'image-item';
      const sizeClass = `image-item-${100 / this.imageColumns}`; // 根据列数计算宽度百分比
      return `${baseClass} ${sizeClass}`;
    },
    goToUrl(url) {
      window.open(url, '_blank'); // 在新标签页中打开链接
      // 或者使用 window.location.href = url; 在当前标签页中打开链接
    },
    load(){
      this.request.get("/threed/page",{
        params:{
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          name:this.name,
          typeId:this.typeId
        }
      }).then(res=>{
        if(res.code==='200'){
          this.items=res.data?.records || []
          this.total=res.data?.total || 0
        }
      })
    },
    changeType(id) {
      this.typeId = id
      this.load()
    },
    loadType(){
      this.request.get("/type").then(res=>{
        this.types=res.data
      })
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum
      this.load()
    },
    reset(){
      this.name=''
      this.typeId=0
      this.load()
    }
  }
};
</script>

<style lang="scss" scoped>
.image-item {
  box-sizing: border-box;
  padding: 10px;
}

.image-item-25 {
  width: 25%;
}

.image-item-50 {
  width: 50%;
}

.image-item-100 {
  width: 100%;
}
.info{
  height: 15px;
  line-height: 1.2;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 这里是超出几行省略 */
  overflow: hidden;
}

.home-container {
  width: 70%;
  margin: 0 auto;
  .type-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .type-left{
      flex: 1;
      display: flex;
      align-items: center;
    }
    .type-item{
      flex: 1;
      text-align: center;
    }
    .type-search{
      display: flex;
    }
  }
  .item-center{
    .el-divider--horizontal {
      display: block;
      height: 1px;
      width: 100%;
      margin: 10px 0;
    }
    margin-top: 20px;
  }
}
</style>
